import { BlueContainer, Heading, Paragraph } from '@app/shared/ui/atoms/Common';
import { Advice } from '@app/shared/types/pages/dailyCardResult';

interface ListItemProps extends Advice {
  icon: string;
}

export function ListItem({ icon, title, description }: ListItemProps) {
  return (
    <BlueContainer className="flex flex-col gap-4">
      <div className="flex items-center gap-4">
        <Heading level={1} className="leading-none">
          {icon}
        </Heading>
        <Heading level={4} className="leading-none">
          {title}
        </Heading>
      </div>
      <Paragraph className="font-normal opacity-60" variant="card">
        {description}
      </Paragraph>
    </BlueContainer>
  );
}
